// extracted by mini-css-extract-plugin
export default {"Dashboard":"Dashboard_Dashboard__qpS8J","Spacer":"Dashboard_Spacer__G0-QZ","ActionsDiv":"Dashboard_ActionsDiv__K6n4g","TabsDiv":"Dashboard_TabsDiv__C4n4O"};